// extracted by mini-css-extract-plugin
export default {"lazy-wrapper":"lazy-wrapper--lJemH","lazy-wrapper__image":"lazy-wrapper__image--dE7HF"};